import { Component } from 'vue'
import NiceModal from 'vue-nice-modal'
import GroupPopup from '@xt/www/components/messageModalQueue/GroupPopup/index.vue'
import AgreementModal from '@xt/www/components/messageModalQueue/AgreementModal/index.vue'
import OrderCouponGift from '@xt/www/components/messageModalQueue/OrderCouponGift/index.vue'
import GiftModal from '@xt/www/components/messageModalQueue/GiftModal/index.vue'
import TopicTipModal from '@xt/www/components/messageModalQueue/TopicTipModal/index.vue'
import OrderCouponGiftH5 from '@xt/mobile/components/messageModalQueue/OrderCouponGift/index.vue'
import GiftModalH5 from '@xt/mobile/components/messageModalQueue/GiftModal/index.vue'
import GroupPopupH5 from '@xt/mobile/components/messageModalQueue/GroupPopup/index.vue'
import AgreementModalH5 from '@xt/mobile/components/messageModalQueue/AgreementModal/index.vue'
import SatisfiedPopup from '@xt/mobile/components/messageModalQueue/SatisfiedPopup/index.vue'
import { EnumRegisterModalNames } from '@xt/client/enums/messageModalQueue/index'
import { $service } from '@xt/client/experimental/request/service'
import { GiftsResponse } from '@xt/client/entities/user/types'
import { EnumApiOrder } from '@xt/client/api/order'
import { EnumProductType } from '@xt/client/enums/product'
import { type IMessageResp } from './types'

// 弹窗组件 - 注册表
const MODAL_MAP: {
  [key in EnumRegisterModalNames]?: Component
} = {
  [EnumRegisterModalNames.Topic]: TopicTipModal,
  [EnumRegisterModalNames.Gift]: GiftModal,
  [EnumRegisterModalNames.Coupon]: OrderCouponGift,
  [EnumRegisterModalNames.Agreement]: AgreementModal,
  [EnumRegisterModalNames.GroupPopup]: GroupPopup
}

const MODAL_MAP_H5: {
  [key in EnumRegisterModalNames]?: Component
} = {
  [EnumRegisterModalNames.Gift]: GiftModalH5,
  [EnumRegisterModalNames.Coupon]: OrderCouponGiftH5,
  [EnumRegisterModalNames.Agreement]: AgreementModalH5,
  [EnumRegisterModalNames.GroupPopup]: GroupPopupH5,
  [EnumRegisterModalNames.SatisfiedPopup]: SatisfiedPopup
}

export function registerNiceModalComponent(client: 'pc' | 'h5' = 'pc') {
  const modalMap = client === 'pc' ? MODAL_MAP : MODAL_MAP_H5
  Object.entries(modalMap).forEach(([modalName, component]) => {
    NiceModal.unregister(modalName)
    NiceModal.register(modalName, NiceModal.create(component))
  })
}

export function transformGiftsForAccountDisplay(list: Array<GiftsResponse>) {
  return list.map(item => {
    let unit: string = '节'

    switch (item.productType) {
      case EnumProductType.single:
      case EnumProductType.fullstage:
        unit = '节'
        break
      case EnumProductType.dayCourse:
      case EnumProductType.selfStudy:
        unit = '天'
        break
      case EnumProductType.onlineExhibition:
      case EnumProductType.offlineExhibition:
        unit = '关'
        break
    }

    return {
      ...item,
      unit
    }
  })
}

/**
 * 我的礼物列表
 * @type {Array<GiftsResponse>}
 * @memberof MessageModalQueue
 */
export async function getGiftsData() {
  const [err, res] = await $service<Array<GiftsResponse>>({
    url: EnumApiOrder.OrderGifts
  })

  if (err || !Array.isArray(res) || !res.length) return []

  return res
}

export function parseJson<T>(data: Pick<IMessageResp, 'bizData'>) {
  if (!data.bizData || !data.bizData.jsonContent || typeof data.bizData.jsonContent !== 'string') return null

  try {
    return JSON.parse(data.bizData.jsonContent) as T
  } catch (e) {
    return null
  }
}
